import { Component, OnInit } from '@angular/core';
import { UserPlaceService } from '../../services/user-place.service';

@Component({
    selector: 'app-current-place-description',
    templateUrl: './current-place-description.component.html',
    styleUrls: ['./current-place-description.component.scss'],
    standalone: false
})
export class CurrentPlaceDescriptionComponent implements OnInit {

  currentPlaceName: string

  constructor(private readonly _userPlaceService: UserPlaceService) {
  }

  ngOnInit(): void {
    this.getCurrentPlaceName();
  }

  private async getCurrentPlaceName(): Promise<void> {
    const currentUserPlace = await this._userPlaceService.getCurrentUserPlace();
    this.currentPlaceName = currentUserPlace.name;
  }
}
